module.exports = __webpack_public_path__ + "img/img_charge_phone_banner.5b31c42d.png";